export default __webpack_public_path__ + "static/benifitImage-f215c6c13b987afe853f2be71650b50e.png";